// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".actionDetail__inner[data-v-373eef66] {\n  max-height: 500px;\n  overflow-x: auto;\n}\n.actionReminderCallout[data-v-373eef66] {\n  width: 500px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
